import React from "react";

const logline = <p>This is a science fiction satirical comedy-drama series about a character in search of his role in an on-screen world that has been taken over by bad actors. It’s like “The Truman Show” but everyone is Truman and it’s not a show – it’s real.</p>;

export default logline;